var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({style:({ width: typeof _vm.width === 'number' ? _vm.width + 'px' : _vm.width }),attrs:{"placeholder":_vm.placeholder,"size":_vm.size,"maxlength":_vm.max},on:{"input":_vm.handleInput},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}},'el-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }